// Service 25 — ทะเบียนรถ / ใบขับขี่ / ขนส่ง และเอกสารยานยนต์สำหรับชาวต่างชาติ
// อ้างอิงหลัก: กรมการขนส่งทางบก (dlt.go.th) ตาม พ.ร.บ.รถยนต์ พ.ศ. 2522 และ พ.ร.บ.การขนส่งทางบก พ.ศ. 2522,
// กรมศุลกากร (customs.go.th) สำหรับการนำเข้า-ส่งออกรถและของใช้ในบ้านเรือน,
// พ.ร.บ.จราจรทางบก พ.ศ. 2522 และที่แก้ไขเพิ่มเติม, พ.ร.บ.คุ้มครองผู้ประสบภัยจากรถ พ.ศ. 2535 (ประกัน พ.ร.บ.),
// อนุสัญญาว่าด้วยการจราจรทางถนน เจนีวา ค.ศ. 1949 และเวียนนา ค.ศ. 1968 (ไทยเป็นภาคีทั้งสองฉบับ),
// กรมการปกครอง (bora.dopa.go.th) และ สตม. (immigration.go.th) สำหรับหลักฐานที่พักอาศัย,
// กรมการกงสุล (consular.mfa.go.th) สำหรับรับรองคำแปลและนิติกรณ์เอกสารยานยนต์ที่ใช้ต่างประเทศ
// Client-safe definitions only. ไม่ระบุราคาบริการในเนื้อหา

export type VehicleFaqCategory =
  | "vehicle-registration"
  | "import-export-vehicle"
  | "driving-licence-foreigner"
  | "vehicle-poa-documents"
  | "tax-inspection-renewal"
  | "motorcycle-rental"
  | "traffic-fines-accidents"
  | "commercial-transport";

export interface VehicleCategoryDef {
  slug: VehicleFaqCategory;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  matchTh: RegExp;
  matchEn: RegExp;
}

export const VEHICLE_FAQ_CATEGORIES: VehicleCategoryDef[] = [
  {
    slug: "vehicle-registration",
    titleTh: "จดทะเบียนรถและโอนกรรมสิทธิ์ในชื่อชาวต่างชาติ",
    titleEn: "Registering a vehicle and transferring ownership as a foreigner",
    descTh:
      "เอกสารที่นายทะเบียนขอเมื่อชาวต่างชาติจดทะเบียนรถหรือรับโอนรถ ทั้งหนังสือเดินทาง หลักฐานการอยู่ในราชอาณาจักร ใบรับรองถิ่นที่อยู่จากสถานทูตหรือ ตม. และขั้นตอนแจ้งย้ายรถข้ามจังหวัดตาม พ.ร.บ.รถยนต์ พ.ศ. 2522",
    descEn:
      "The documents the registrar asks a foreigner for when registering or receiving transfer of a vehicle: passport, evidence of permission to stay, a certificate of residence from an embassy or Immigration, and the procedure for moving a registration between provinces under the Motor Vehicle Act B.E. 2522.",
    matchTh: /จดทะเบียนรถ|โอนกรรมสิทธิ์|เล่มทะเบียน|สมุดคู่มือ|แจ้งย้าย|ใบรับรองถิ่นที่อยู่|นายทะเบียน/,
    matchEn: /register(ing)? a vehicle|ownership transfer|transfer of ownership|registration book|certificate of residence|registrar/i,
  },
  {
    slug: "import-export-vehicle",
    titleTh: "นำเข้าและส่งออกรถ ของใช้ในบ้านเรือน และรถย้ายถิ่นฐาน",
    titleEn: "Importing and exporting vehicles, household effects and transferring residence",
    descTh:
      "หลักเกณฑ์ของกรมศุลกากรสำหรับนำรถเข้าประเทศ ใบอนุญาตนำเข้าจากกรมการค้าต่างประเทศ เอกสารกรรมสิทธิ์เดิม การนำรถเข้าชั่วคราวสำหรับนักท่องเที่ยว และการส่งรถออกไปต่างประเทศ",
    descEn:
      "Thai Customs rules for bringing a vehicle into the country, the import licence from the Department of Foreign Trade, proof of prior ownership, temporary importation for tourists, and shipping a vehicle out of Thailand.",
    matchTh: /นำเข้ารถ|ศุลกากร|นำรถเข้า|ส่งรถออก|ย้ายถิ่นฐาน|อากรขาเข้า|ใบอนุญาตนำเข้า|carnet/i,
    matchEn: /import|customs|export the (car|vehicle)|transfer of residence|duty|carnet/i,
  },
  {
    slug: "driving-licence-foreigner",
    titleTh: "ใบขับขี่สำหรับชาวต่างชาติและใบขับขี่สากล",
    titleEn: "Driving licences for foreigners and international driving permits",
    descTh:
      "การใช้ใบขับขี่สากลตามอนุสัญญาเจนีวา ค.ศ. 1949 และเวียนนา ค.ศ. 1968 การเปลี่ยนใบขับขี่ต่างประเทศเป็นใบขับขี่ไทยที่ขนส่งจังหวัด เอกสารประกอบ การอบรมและทดสอบ รวมถึงคำแปลรับรองที่กรมการขนส่งทางบกยอมรับ",
    descEn:
      "Using an international driving permit under the 1949 Geneva and 1968 Vienna Conventions, converting a foreign licence into a Thai licence at a provincial land transport office, the supporting documents, the training and tests, and the certified translations the Department of Land Transport accepts.",
    matchTh: /ใบขับขี่|ใบอนุญาตขับรถ|IDP|ใบขับขี่สากล|ขนส่งจังหวัด|ทดสอบสมรรถภาพ|อบรม/i,
    matchEn: /driving licen|driver'?s licen|international driving permit|IDP|land transport office|written test|road test/i,
  },
  {
    slug: "vehicle-poa-documents",
    titleTh: "หนังสือมอบอำนาจและเอกสารรับรองสำหรับงานทะเบียนรถ",
    titleEn: "Powers of attorney and certified documents for vehicle registration work",
    descTh:
      "การมอบอำนาจให้ผู้อื่นดำเนินการแทนที่กรมการขนส่งทางบกตาม ป.พ.พ. ลักษณะตัวแทน การรับรองลายมือชื่อโดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร การรับรองคำแปล และการนิติกรณ์ที่กรมการกงสุลเมื่อเอกสารทำจากต่างประเทศ",
    descEn:
      "Appointing an agent to act at the Department of Land Transport under the agency provisions of the Civil and Commercial Code, signature certification by a notarial services attorney, certified translation, and legalisation at the Department of Consular Affairs when the document was executed abroad.",
    matchTh: /หนังสือมอบอำนาจ|มอบอำนาจ|รับรองลายมือชื่อ|รับรองคำแปล|นิติกรณ์|กงสุล/,
    matchEn: /power of attorney|attorney|signature certification|certified translation|legalisation|legalization|consular/i,
  },
  {
    slug: "tax-inspection-renewal",
    titleTh: "ต่อภาษีรถประจำปี ประกัน พ.ร.บ. และการตรวจสภาพ ตรอ.",
    titleEn: "Annual road tax, compulsory insurance and vehicle inspection",
    descTh:
      "ลำดับที่ถูกต้องของการต่อภาษีรถ ตั้งแต่ประกัน พ.ร.บ. ตามพระราชบัญญัติคุ้มครองผู้ประสบภัยจากรถ พ.ศ. 2535 การตรวจสภาพที่สถานตรวจสภาพเอกชน และเงื่อนไขค่าปรับเมื่อขาดต่อภาษี",
    descEn:
      "The correct order for renewing road tax: compulsory insurance under the Protection for Motor Vehicle Accident Victims Act B.E. 2535, inspection at an authorised private inspection station, and the surcharge rules when the tax lapses.",
    matchTh: /ต่อภาษี|ภาษีรถ|ป้ายวงกลม|ตรวจสภาพ|ตรอ\.|พ\.ร\.บ\.รถ|ประกัน พ\.ร\.บ\./,
    matchEn: /road tax|tax renewal|inspection station|compulsory insurance|surcharge/i,
  },
  {
    slug: "motorcycle-rental",
    titleTh: "รถจักรยานยนต์ บิ๊กไบค์ และรถเช่าสำหรับชาวต่างชาติ",
    titleEn: "Motorcycles, big bikes and rental vehicles for foreigners",
    descTh:
      "ประเภทใบอนุญาตขับรถจักรยานยนต์ที่ถูกต้อง ข้อกำหนดหมวกนิรภัยตาม พ.ร.บ.จราจรทางบก การเช่ารถและปัญหาการยึดหนังสือเดินทางเป็นหลักประกัน รวมถึงความคุ้มครองประกันเมื่อขับขี่โดยไม่มีใบอนุญาตที่ถูกต้อง",
    descEn:
      "The correct motorcycle licence class, helmet requirements under the Road Traffic Act, renting a vehicle and the problem of passports held as security, and how insurance responds when the rider holds no valid licence.",
    matchTh: /จักรยานยนต์|บิ๊กไบค์|มอเตอร์ไซค์|เช่ารถ|หมวกนิรภัย/,
    matchEn: /motorcycle|motorbike|big bike|rental|helmet/i,
  },
  {
    slug: "traffic-fines-accidents",
    titleTh: "ใบสั่ง ค่าปรับจราจร และเอกสารหลังเกิดอุบัติเหตุ",
    titleEn: "Traffic tickets, fines and documents after an accident",
    descTh:
      "ผลของใบสั่งค้างชำระต่อการต่อภาษีรถประจำปี ช่องทางชำระค่าปรับ การขอบันทึกประจำวันจากสถานีตำรวจเพื่อใช้เคลมประกันหรือใช้ต่างประเทศ และเอกสารที่ต้องแปลและรับรองเมื่อผู้เสียหายเป็นชาวต่างชาติ",
    descEn:
      "How unpaid tickets affect annual road tax renewal, how to pay fines, obtaining the police daily record for an insurance claim or for use abroad, and which documents need translation and certification when the injured party is a foreigner",
    matchTh: /ใบสั่ง|ค่าปรับ|จราจร|อุบัติเหตุ|บันทึกประจำวัน|ประจำวัน/,
    matchEn: /ticket|fine|traffic|accident|police (report|record)/i,
  },
  {
    slug: "commercial-transport",
    titleTh: "รถขนส่ง ป้ายเหลือง และใบอนุญาตขับรถตามกฎหมายขนส่ง",
    titleEn: "Commercial vehicles, yellow plates and land transport licences",
    descTh:
      "ความต่างระหว่าง พ.ร.บ.รถยนต์ พ.ศ. 2522 และ พ.ร.บ.การขนส่งทางบก พ.ศ. 2522 ใบอนุญาตขับรถทุกประเภทตามกฎหมายขนส่ง การขออนุญาตประกอบการขนส่ง และข้อจำกัดอาชีพของคนต่างด้าว",
    descEn:
      "The difference between the Motor Vehicle Act B.E. 2522 and the Land Transport Act B.E. 2522, the transport driving licence classes, applying for a transport operator licence, and the occupational restrictions that apply to foreigners.",
    matchTh: /ขนส่งทางบก|ป้ายเหลือง|รถบรรทุก|ประกอบการขนส่ง|รถโดยสาร|รถสาธารณะ/,
    matchEn: /land transport act|yellow plate|truck|transport operator|public (car|vehicle)|commercial vehicle/i,
  },
];

export function getVehicleCategoryDef(slug: string): VehicleCategoryDef | undefined {
  return VEHICLE_FAQ_CATEGORIES.find((c) => c.slug === slug);
}